import React, { useCallback, useEffect } from 'react';
import { Button, IconButton, Modal } from '@material-ui/core';
import { ArrowRight, X } from 'phosphor-react';
import { withRouter } from 'next/router';
import OtpInput from 'react-otp-input';

import {
  sendVerification,
  toggleEmailVerifyModal,
} from '../../../../../actions/dashboard';
import { EmailVerificationIcon } from '../../../../utility/Icons';
import { verifyUser } from '../../../../../actions/auth';
import styles from '../../../../../styles/sass/components/Verification.module.scss';

interface EmailModalProps {
  dispatch: Function;
  email: string;
  showEmailVerifyModal: boolean;
  modalStyle: any;
  token: string;
  router: any;
}

export function EmailVerificationModal({
  dispatch,
  email,
  showEmailVerifyModal,
  modalStyle,
  token,
  router,
}: EmailModalProps) {
  const [otp, setOtp] = React.useState('');

  useEffect(() => {
    if (router.query.code) {
      setOtp(router.query.code);
    }
  }, []);

  const handleEmailVerify = () => {
    dispatch(verifyUser({ emailVerificationToken: otp }, token));
  };

  const handleResend = useCallback(() => {
    dispatch(sendVerification('email', token, true));
  }, []);

  const valid = otp && otp.length === 6;
  return (
    <Modal
      open={showEmailVerifyModal}
      onClose={() => dispatch(toggleEmailVerifyModal(false))}
      style={modalStyle}
    >
      <div className={styles.verificationModal}>
        <div className={styles.header}>
          <EmailVerificationIcon />
          <IconButton
            onClick={() => dispatch(toggleEmailVerifyModal(false))}
            className={styles.xIcon}
          >
            <X size={32} color="#323232" weight="regular" />
          </IconButton>
        </div>
        <h3 className={styles.title}>Let’s verify your email address</h3>
        <p className={styles.subText}>
          Code sent to <b>{email}</b>
        </p>

        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          shouldAutoFocus
          placeholder={'000000'}
          isInputNum
          containerStyle={styles.otpContainer}
          inputStyle={styles.otpInput}
          focusStyle={styles.optInputFocused}
        />
        <h3 className={styles.title}>Didn’t receive your code?</h3>
        <h3 onClick={handleResend} className={styles.resend}>
          Resend
        </h3>

        <Button
          onClick={handleEmailVerify}
          disabled={!valid}
          className={`${styles.verifyButton} ${
            valid ? styles.validButton : styles.invalidButton
          }`}
        >
          Verify{' '}
          <ArrowRight
            color={valid ? '#ffffff' : '#E2E2E2'}
            size={32}
            style={{ marginLeft: 10 }}
          />
        </Button>
      </div>
    </Modal>
  );
}

export default withRouter(EmailVerificationModal);
